import Vue from "vue";
// import axios from 'axios'
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index.js";
import "./plugins/element.js";
import modal from "./plugins/modal.js";
import tools from "./utils/tools.js";
import VCharts from "v-charts";
import host from "./utils/index.js";
import service from "./utils/service.js";
import Print from "vue-print-nb";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas);
Vue.use(VCharts);
Vue.use(Print); //注册
Vue.prototype.host = host;
Vue.prototype.service = service;
// Vue.prototype.$axios = axios
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.prototype.$modal = modal;
Vue.prototype.$tools = tools;

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	if (!to.meta.keepAlive)
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	if (savedPosition) {
		return savedPosition;
	} else {
		return false;
	}
};

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import jp from "./locales/jp.js";
import en from "./locales/en.js";
import zh from "./locales/zh.js";

const i18n = new VueI18n({
	locale: "jp",
	messages: {
		en,
		jp,
		zh,
	},
});

new Vue({
	router,
	store,
	i18n,
	scrollBehavior,
	render: (h) => h(App),
}).$mount("#app");
